import { useState } from 'react'

import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { useFilters } from 'modules/shift_management/hooks/useFilters'
import { usePagination } from 'modules/shift_management/hooks/usePagination'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { useUI } from 'modules/shift_management/hooks/useUI'
import { createLocationEntities } from 'modules/shift_management/lib/createLocationEntity'
import { useAllLocations } from 'modules/shift_management/lib/useSelectableLocations'

const useLocationSelector = () => {
  const [selected, setSelected] = useState<EntitySelectEntity[]>([])
  const [filters, dispatchFilters] = useFilters()
  const { loading, locations } = useAllLocations()
  const [, dispatchUI] = useUI()
  const [, dispatchShiftsRows] = useShiftsRows()
  const [, dispatchPagination] = usePagination()

  useUnsafeEffect(() => {
    if (loading || locations.length <= 0) return

    const selectedEntities = createLocationEntities(filters.locationIds, locations)
    if (selectedEntities.length <= 0) return
    updateSelected(selectedEntities)
  }, [filters.locationIds, locations.length, loading])

  const updateSelected = (selectedLocations: EntitySelectEntity[]) => {
    setSelected(selectedLocations)
  }

  const applyLocationSelection = (selectedLocations: EntitySelectEntity[]) => {
    const selectedLocationIds = selectedLocations.map((location) => String(location.id))
    dispatchFilters({
      type: 'SET_LOCATIONS',
      locationIds: selectedLocationIds,
    })

    dispatchUI({ type: 'LOADING' })
    dispatchShiftsRows({ type: 'RESET_SHIFTS_ROWS' })
    dispatchPagination({ type: 'RESET_PAGINATION' })
  }

  return {
    selected,
    updateSelected,
    applyLocationSelection,
  }
}

export { useLocationSelector }
